module.exports = __webpack_public_path__ + "img/tarj1-1.c0599373.svg";